import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralHistoryPersonalCompleteModel } from 'src/app/model/general/history-personal-complete';
import { HISTORY_PERSONAL_COMPLETE_CONSTANTS } from './history-personal-complete.constants';
import { HistoryPersonalCompleteService } from './history-personal-complete.service';

@Component({
  selector: 'ms-history-personal-complete',
  templateUrl: './history-personal-complete.component.html',
  styleUrls: ['../history.styles.scss'],
})
export class HistoryPersonalCompleteComponent extends BaseComponent {
  readonly screen = HISTORY_PERSONAL_COMPLETE_CONSTANTS;
  history: GeneralHistoryPersonalCompleteModel = {};
  expandSection = true;

  constructor(protected service: HistoryPersonalCompleteService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getHistory().subscribe((history) => {
        this.history = {
          ...history,
          lastMenstruation: history.lastMenstruation
            ? new Date(history.lastMenstruation)
            : undefined,
          lastCytology: history.lastCytology
            ? new Date(history.lastCytology)
            : undefined,
          lastBirth: history.lastBirth
            ? new Date(history.lastBirth)
            : undefined,
        };
      }),
      this.service.getPersonId().subscribe((person) => {
        if (person != null) {
          this.subscriptions.push(this.service.loadHistory(person).subscribe());
        }
      }),
      this.service.isSaving().subscribe((saving) => {
        if (saving) {
          this.subscriptions.push(this.service.save(this.history).subscribe());
        }
      })
    );
  };

  lastMenstruationChanged = (e: any) =>
    (this.history.lastMenstruation = e.value);

  lastBirthChanged = (e: any) => (this.history.lastBirth = e.value);

  lastCytologyChanged = (e: any) => (this.history.lastCytology = e.value);
}
